import { z } from "zod/v4";

export const KlaviyoUserRequestPathParamsSchema = z.object({
  klaviyoCookie: z.string(),
  orgId: z.uuid(),
});

export type KlaviyoUserRequestPathParamsType = z.infer<
  typeof KlaviyoUserRequestPathParamsSchema
>;

export type KlaviyoProfileProperties = {
  [key: string]: any;
};

export type KlaviyoProfileResponse = {
  data: Array<{
    attributes: {
      properties: KlaviyoProfileProperties;
    };
  }>;
};
